export default __webpack_public_path__ + "static/media/delete.85d07126.png";